import { CMSApiResponse }               from "framework/http/CMSApiClient"
import { RunContextApp }                from "framework/RCApp"
import { CreateSurveyTemplate, 
         GetSurveyTemplates, 
         UpdateAllTemplates,
         PublishTemplates,
         UnpublishTemplates,
         DiscardAllDraftTemplates
       }                                from "types/apis/surveyInterfaces"
import { APIData, 
         QA_WORKFLOW 
       }                                from "types/cms/frontendTypes"

export const SurveyTemplateAPI = {

  createTemplate : async (rc : RunContextApp, utilityDocumentId : string, templateData : CreateSurveyTemplate.params) : Promise<CMSApiResponse<CreateSurveyTemplate.retval>> => {
    const resp = await rc.cmsApiClient.post<CreateSurveyTemplate.retval>(
      CreateSurveyTemplate.apiEndpoint,
      {
        utilityDocumentId : utilityDocumentId,
        ...templateData
      }
    )
    return resp
  },

  getTemplates : async (rc : RunContextApp, utilityDocumentId : string) : Promise<CMSApiResponse<GetSurveyTemplates.retval>> => {

    const resp = await rc.cmsApiClient.get<GetSurveyTemplates.retval>(
      `${GetSurveyTemplates.apiEndpoint}?utilityDocumentId=${utilityDocumentId}`)
    return resp
  },

  updateAllTemplates : async (rc : RunContextApp, params : UpdateAllTemplates.params) : Promise<CMSApiResponse<UpdateAllTemplates.retval>> => {

    const resp = await rc.cmsApiClient.post<UpdateAllTemplates.retval>(UpdateAllTemplates.apiEndpoint, params)
    return resp
  },

  publishAllTemplates : async (rc : RunContextApp, 
                               templateDocIds : string[]) : Promise<CMSApiResponse<PublishTemplates.retval>> => {

    const resp = await rc.cmsApiClient.post<PublishTemplates.retval>(PublishTemplates.apiEndpoint, {
      data : templateDocIds
    })
    return resp
  },

  unpublishAllTemplates : async (rc : RunContextApp, 
                                 templateDocIds : string[]) : Promise<CMSApiResponse<UnpublishTemplates.retval>> => {

    const resp = await rc.cmsApiClient.post<UnpublishTemplates.retval>(UnpublishTemplates.apiEndpoint, {
      data : templateDocIds
    })
    return resp
  },

  discardAllDraftTemplates : async (rc : RunContextApp, 
                                    utilityDocumentId : string,
                                    templateDocIds : string[]) : Promise<CMSApiResponse<DiscardAllDraftTemplates.retval>> => {

    const resp = await rc.cmsApiClient.post<DiscardAllDraftTemplates.retval>(DiscardAllDraftTemplates.apiEndpoint, {
      utilityDocumentId : utilityDocumentId,
      data : templateDocIds
    })
    return resp
  },

  getReviewWorkflow : async (rc : RunContextApp) : Promise<CMSApiResponse<QA_WORKFLOW>> => {
    const resp = await rc.cmsApiClient.get<QA_WORKFLOW>('/survey/getTemplateReviewWorkflow')
    return resp
  }
}